document.addEventListener("DOMContentLoaded", async function () {
  try {
    await window.loadSwiper();
  } catch (error) {
    console.error('[yg-swiper-banner2] Unable to load Swiper.', error);
    return;
  }

  (function () {
    const swiperBlockList = document.querySelectorAll(".yg-swiper-banner-list2 .swiper-slide");

    // 控制视频播放/暂停
    function swiperActive(swiper) {
      swiperBlockList.forEach(function (swiperBlock) {
        let [video1, video2] = swiperBlock.querySelectorAll(".yg-swiper-media-video");

        if (swiperBlock.classList.contains("swiper-slide-active")) {
          if (video1) video1.play();
          if (video2) video2.play();
        } else {
          if (video1) video1.pause();
          if (video2) video2.pause();
        }
      });
    }


    // 修改分页器的激活状态
    function changePagination(swiper) {
      const bullets = document.querySelectorAll('.swiper-pagination-bullet');

      // 确保分页器存在
      if (bullets.length > 0) {
        let activeIndex;
        let maxSlides;

        // 根据显示模式设置激活逻辑
        if (showTwoSlide) {
          maxSlides = 2;
          activeIndex = swiper.realIndex % maxSlides; // 计算分页器激活索引
        } else if (showThreeSlide) {
          maxSlides = 3;
          activeIndex = swiper.realIndex % maxSlides; // 计算分页器激活索引
        }

        // 如果设置了有效的最大分页器数量
        if (maxSlides) {
          // 重置所有分页器状态
          bullets.forEach((bullet, index) => {
            if (index === activeIndex) {
              bullet.classList.add('swiper-pagination-bullet-active');
            } else {
              bullet.classList.remove('swiper-pagination-bullet-active');
            }
          });
        }
      }
    }

    // 初始化 Swiper 组件
    function initSwiper() {

      let ygSwiperText = new Swiper(".yg-swiper-banner-text", {
        wrapperClass: "swiper-wrapper-text",
        slideClass: "swiper-slide-text",
        effect: 'fade',
        loop: true
        // autoHeight: true
      });

      let newSwiper = new Swiper(".yg-swiper-banner-list2", {
        spaceBetween: window.innerWidth < 768 ? 0 : slideSpace,
        initSwiper: 1,
        slidesPerView: 'auto',
        centeredSlides: true,
        slideToClickedSlide: true,
        loop: true,
        autoHeight: true,
        setWrapperSize: true, 
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: changePagination,
          slideChangeTransitionEnd: swiperActive,
          init: function (swiper) {
            console.log('showThreeSlide', showThreeSlide)
            const paginationEl = document.querySelector('.swiper-pagination');
            if (paginationEl) {
              const observer = new MutationObserver(() => {
                const bullets = document.querySelectorAll('.swiper-pagination-bullet');
                if (bullets.length >= 6) {
                  if (showTwoSlide) {
                    if (bullets[2]) bullets[2].style.display = 'none';
                    if (bullets[3]) bullets[3].style.display = 'none';
                  } else if (showThreeSlide) {
                    if (bullets[3]) bullets[3].style.display = 'none';
                    if (bullets[4]) bullets[4].style.display = 'none';
                    if (bullets[5]) bullets[5].style.display = 'none';
                  }
                  observer.disconnect();
                }
              });

              observer.observe(paginationEl, { childList: true, subtree: true });
            }
            setTimeout(() => {
              if (showTwoSlide || showThreeSlide) {
                swiper.slideToLoop(slideCount, 0, false); 
              }
              else {
                swiper.slideToLoop(0, 0, false); 
              }
            }, 10);

          }
          // click: function (swiper, event) {
          //   const clickedIndex = swiper.clickedIndex;
          //   console.log('currentIndex')
          //   swiper.slideToLoop(clickedIndex);
          // }
        },
        thumbs: {
          swiper: ygSwiperText,
        },
        controller: {
          control: ygSwiperText,  // 让 newSwiper 控制 ygSwiperText
        },
        breakpoints: {
            768: {
              spaceBetween: 15
            },
            0: {
              spaceBetween: 0
            }
        }
      });
    }

    // 执行 Swiper 初始化
    initSwiper();

  })();
});
